export default __webpack_public_path__ + "static/media/play.87abd71a.svg";